<template>
<div class="content">
    <div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
        <view-job>
        </view-job> 
        </div>
    </div>  
    </div>
</div>
</template>
<script>
/* eslint-disable */
import viewJob from './todo-view-job-information'
export default {
    components: {
        viewJob
    }
}
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-job-information/base-view-job-information.vue